var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb',{attrs:{"location":"Brand Film"}}),_c('title-area'),_c('film',{attrs:{"filmInfo":_vm.filmInfo.HAIR_CARE}}),_c('film02',{attrs:{"filmInfo":_vm.filmInfo.BODY_CARE}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }